module.exports = __webpack_public_path__ + "static/media/59 - LOGO KOSTAF PNG.99cb71c0.png";